export default __webpack_public_path__ + "static/media/chat-icon3-restricted.f9685c7e.svg";